import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { FlujoVentaPasoComplementarioControl } from '../_models/flujo-venta-paso-complementario-control';

@Injectable({
  providedIn: 'root'
})
export class FlujoVentaPasoComplementarioControlService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/flujoVentaPasosComplementariosControles';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as FlujoVentaPasoComplementarioControl[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as FlujoVentaPasoComplementarioControl[] ) );
  }

  listadoPorIdFlujoPaso( id: string ) {
    return this.httClient.get( this.rutServicio + '/flujoVentaPaso/' + id ).pipe( map( res => res as FlujoVentaPasoComplementarioControl[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as FlujoVentaPasoComplementarioControl ) );
  }

  crear( regCrear: FlujoVentaPasoComplementarioControl ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as FlujoVentaPasoComplementarioControl ) );
  }

  actualizar( regActualizar: FlujoVentaPasoComplementarioControl ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as FlujoVentaPasoComplementarioControl ) );
  }

  bulk( registros: FlujoVentaPasoComplementarioControl[] ) {
    registros.forEach( e => {
      e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( `${ this.rutServicio }/bulk`, registros ).pipe( map( res => res as FlujoVentaPasoComplementarioControl[] ) );
  }
}
